import { decamelize, decamelizeKeys } from 'xcase';

import localAxios from '../localAxios';

export interface Payload {
  insertionOrder: number;
  questions: Array<Question>;
}

export interface Question {
  explanation: string;
  questionText: string;
  gradingWeight: number;
  answers: Answer[];
  type: string;
}

export interface Answer {
  order: number;
  text: string;
  isCorrect: boolean;
}

interface AddBulkQuestionsParams {
  insertionOrder: number;
  questions: Array<Question>;
  quizId: string | number;
  bulkAddQuestionUrl: (params: { quizId: string | number }) => string;
}

export async function addBulkQuestions({
  quizId,
  bulkAddQuestionUrl,
  ...params
}: AddBulkQuestionsParams) {
  const data: Payload = decamelizeKeys(params);
  const url = bulkAddQuestionUrl({ quizId });
  const response = await localAxios.post(url, data);

  return response.data;
}
